import script from "./DateInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=ts"

import "./DateInput.vue?vue&type=style&index=0&id=0e779e1c&lang=css"

const __exports__ = script;

export default __exports__